import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import './index.css';
import App from './App';
import { GlobalStateProvider } from './utils/GlobalStateProvider';
import { queryClient } from './config/api/queries';
import ModalProvider from 'mui-modal-provider';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { theme } from './utils/theme';
import { PostHogProvider } from 'posthog-js/react';

ReactDOM.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={{ api_host: 'https://app.posthog.com' }}
    >
      <QueryClientProvider client={queryClient}>
        <GlobalStateProvider>
          <ThemeProvider theme={theme}>
            <ModalProvider>
              <App />
            </ModalProvider>
          </ThemeProvider>
        </GlobalStateProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </PostHogProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
